import { render, staticRenderFns } from "./Docket.vue?vue&type=template&id=ce48419e&scoped=true&"
import script from "./Docket.vue?vue&type=script&lang=js&"
export * from "./Docket.vue?vue&type=script&lang=js&"
import style0 from "./Docket.vue?vue&type=style&index=0&id=ce48419e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce48419e",
  null
  
)

export default component.exports